__webpack_require__.p = "https://myhr-assistant-ui.integ.amazon.work/";